<template>
  <div id="form-builder-element-edit-64um9q"
    class="container-edit bg-light pt-2"
    :class="editingElement ? 'container-edit-show' : ''"
  >
    <div id="form-builder-element-edit-cy3nye" class="container-inner">
      <div id="form-builder-element-edit-ui07iu" class="d-flex justify-content-between">
        <h6 id="form-builder-element-edit-228sfl">
          <b-icon-chevron-left id="form-builder-element-edit-abr7j3"
            class="icon-close"
            @click="setFormBuilderEditingElementEdit()"
          ></b-icon-chevron-left>
          Edit Element
        </h6>
        <small id="form-builder-element-edit-hcz4e4"
          v-if="advancedOptions"
          @click="toggleShowType"
          class="hover-pointer text-primary"
          >{{ showType == "basic" ? "Advanced" : "Basic" }}</small
        >
      </div>
      <fb-form-element-properties id="form-builder-element-edit-awisgk"
        :formId="formId"
        :showType="showType"
      ></fb-form-element-properties>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "FormBuilderElementEdit",
  props: ["formId"],
  data() {
    return {
      showType: "basic"
    };
  },
  methods: {
    ...mapMutations("formBuilder", [
      "setFormBuilderEditingElement",
      "setFormBuilderSelectedElementControlId"
    ]),
    setFormBuilderEditingElementEdit() {
      this.setFormBuilderSelectedElementControlId({
        selectedElementControlId: null,
        formId: this.formId
      });
      this.setFormBuilderEditingElement({
        editing: false,
        formId: this.formId
      });
    },
    toggleShowType() {
      if (this.showType == "basic") this.showType = "advanced";
      else this.showType = "basic";
    }
  },
  computed: {
    ...mapState("formBuilder", {
      forms: state => state.form
    }),
    ...mapState("layout", {
      advancedOptions: state => state.advancedOptions
    }),
    editingElement() {
      return this.forms[this.formId].editingElement;
    }
  }
};
</script>

<style>
.container-edit {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  width: 0;
  z-index: 1;
  transition: width 0.5s;
  overflow-x: hidden;
}
.container-edit-show {
  width: 350px;
}
.border-wider {
  border-width: 10px !important;
}
.container-inner {
  width: 350px;
  padding-left: 15px;
  padding-right: 15px;
}
.icon-close:hover {
  cursor: pointer;
}
</style>
